var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_520_1060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9395 3.73047H9.68945V10.6879L14.2056 12.8343L14.7422 11.7054L10.9395 9.89801V3.73047Z",
    fill: "#F4C343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3335 0.625C5.15584 0.625 0.958496 4.82234 0.958496 10C0.958496 15.1777 5.15584 19.375 10.3335 19.375C15.5112 19.375 19.7085 15.1777 19.7085 10C19.7085 4.82234 15.5112 0.625 10.3335 0.625ZM10.3335 18.125C5.84619 18.125 2.2085 14.4873 2.2085 10C2.2085 5.5127 5.84619 1.875 10.3335 1.875C14.8208 1.875 18.4585 5.5127 18.4585 10C18.4585 14.4873 14.8208 18.125 10.3335 18.125Z",
    fill: "#F4C343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_520_1060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.03d85f7ff5b73a0b8546facbcf84671c.svg";
export { ForwardRef as ReactComponent };